export default __webpack_public_path__ + "ce927d4c550bc367159477a5bedea99c.png";